var lg_EC970W = {
    name: "EC970W",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,59,245,170,189,245,106,162],
        },
        {
            function: "KEY_EJECTCD",
            name: "KEY_EJECTCD",
            icon: "KEY_EJECTCD",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,191,234,170,162],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,181,189,218,162],
        },
        {
            function: "KEY_CLEAR",
            name: "KEY_CLEAR",
            icon: "KEY_CLEAR",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,170,175,250,162],
        },
        {
            function: "CmSkip",
            name: "CmSkip",
            icon: "CmSkip",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,173,90,222,226],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,181,122,245,98],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,59,245,170,191,234,170,162],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,59,245,170,175,250,170,162],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,59,245,170,171,254,170,162],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,59,245,170,183,246,170,162],
        },
        {
            function: "LP",
            name: "LP",
            icon: "LP",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,189,218,181,162],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,175,250,170,162],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,171,127,106,162],
        },
        {
            function: "KEY_RECORD",
            name: "KEY_RECORD",
            icon: "KEY_RECORD",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,174,253,106,162],
        },
        {
            function: "Reverse",
            name: "Reverse",
            icon: "Reverse",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,183,246,170,162],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,189,245,106,162],
        },
        {
            function: "KEY_FORWARD",
            name: "KEY_FORWARD",
            icon: "KEY_FORWARD",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,171,254,170,162],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,173,253,170,162],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,181,251,170,162],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,170,255,170,162],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,186,250,234,162],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,173,126,234,162],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,181,125,234,162],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,170,191,234,162],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,186,189,122,162],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,173,95,122,162],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,187,245,170,162],
        },
        {
            function: "EzPoweroff",
            name: "EzPoweroff",
            icon: "EzPoweroff",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,189,90,175,98],
        },
        {
            function: "EzRepeat",
            name: "EzRepeat",
            icon: "EzRepeat",
            command: [68,0,4,90,2,5,2,90,2,95,6,71,35,144,17,78,2,54,156,53,107,123,181,173,119,98],
        },
    ]
}
export default lg_EC970W